import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

/**
 * Hook que expone los datos del clínico autenticado (GET /clinician/me).
 *
 * - `staleTime` 5 min: evita refetch innecesario al navegar entre rutas.
 * - `retry: 1`: solo un reintento ante error transitorio (no spam de 401s).
 * - El cache se invalida desde AccountSpecialty cuando el clínico
 *   confirma o cambia su especialidad.
 *
 * Uso:
 *   const me = useClinicianMe();
 *   if (me.isLoading) return <Spinner />;
 *   if (me.data?.needs_specialty_confirmation) ...
 */
export function useClinicianMe() {
  return useQuery({
    queryKey: ["clinician", "me"],
    queryFn: api.getClinicianMe,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
